import { useState } from 'react';

import { Button, Form } from 'antd';
import IconMap from 'assets/icons/pin-map-fill.svg';
import { PageTitle } from 'presentation/components/PageTitle';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { TYPE_FILTER } from '../CU-049-01/constant';
import { Searchparams } from '../CU-055-05/models/Master';
import { SearchBar } from './components/SearchBar';

const CU05501Page = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const [isDisabled, setIsDisabled] = useState<boolean>(true);

    const submit = (value: any) => {
        const data: Searchparams = {
            typeFilter: TYPE_FILTER.fromCU05501,
            keyword: value.searchingText,
        };

        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_049_01}`, {
            state: { dataSearch: data },
        });
    };

    const onClickFilterArea = () => {
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_055_02}`);
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-050-01-container CU-001-04-container CU-055-01-container"
        >
            <PageTitle title="物件検索" />
            <Form
                className="width-full-screen CU-001-04-container"
                style={{
                    height: '100vh',
                }}
                onFinish={submit}
                onValuesChange={(e) => {
                    e.searchingText.trim().length > 2 ? setIsDisabled(false) : setIsDisabled(true);
                }}
                form={form}
            >
                <div style={{ width: 343 }}>
                    <section
                        style={{
                            width: '100%',
                            height: 210,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 24,
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                                height: 40,
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <SearchBar form={form} />
                            <Button
                                className="button-text"
                                type="primary"
                                style={{ width: 64, height: 40 }}
                                disabled={isDisabled}
                                htmlType="submit"
                            >
                                検索
                            </Button>

                        </div>
                        ローマ字表記の箇所はカタカナ、ローマ字表記の地名は漢字でご入力ください。

                        <div
                            className="card-filter-area glow-on-hover"
                            onClick={() => onClickFilterArea()}
                        >
                            <div className="item-filter-area">
                                <div>
                                    <img src={IconMap} />
                                </div>
                                <div className="text-filter-area">エリアから探す</div>
                            </div>
                        </div>
                    </section>
                </div>
            </Form>
        </div>
    );
};
export default CU05501Page;
